import { SpinLoader } from '../../Loader/SpinLoader'
import { Event } from '../../trackers/Tracking'
import { createBookingRequest } from 'apiCalls/BookingRequests'
import { getOriginalFreeBusy } from 'apiCalls/GoogleCalendarRequests'
import axios from 'axios'
import AnimatedCheckMark from 'components/public/booking/AnimatedCheckMark'
import { BookingRequestValidation } from 'components/validation/BookingRequestValidation'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import ReactDatetime from 'react-datetime'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import { VscError, VscCalendar } from 'react-icons/vsc'
import styled, { css } from 'styled-components'
import { freeTimeSlots, disambleOverOneDay, isValidEmail } from 'variables/functions'
import { LINK_BASE, weekDays } from 'variables/general'
import PackageAddOnSelection from '../../admin/bookings/PackageAddOnSelection'
import { TimeSlotsSection } from './TimeSlotsSection'
import { DateTime } from 'luxon'

var ts = require('@mapbox/timespace')

export function BookingRequestModal({
  values,
  setValues,
  handleChange,
  pack,
  loadComplete,
  setLoadComplete,
  marketplace,
  addOns,
  setAddOns,
  isForPreview,
  colorObj,
  showForm,
  packageForm,
  handleChangeWithPackageForm,
}) {
  const [page, setPage] = useState(0)
  const [freeTimes, setFreeTimes] = useState(null)
  const [errors, setErrors] = useState({})
  const [busy, setBusy] = useState([])
  const [timeZone, setTimeZone] = useState('America/Vancouver')
  const [randomDateOfCurrentMonth, setRandomDateOfCurrentMonth] = useState(null)
  const [timeTBD, setTimeTBD] = useState(false)
  const source = axios.CancelToken.source()
  const [waitingForResponse, setWaitingForResponse] = useState(false)
  const [expandCalendar, setExpandCalendar] = useState(false)
  const [openTimeSlots, setOpenTimeSlots] = useState(true)
  const [blockSubmit, setBlockSubmit] = useState(false)

  const cleanData = (busyData) => {
    let busy = Object.keys(busyData).map((calendar_id) => {
      let busyTimes = busyData[calendar_id].busy.map((el) => {
        let startDate = new Date(el['start'])
        let endDate = new Date(el['end'])

        const date = new Date(startDate.getTime())

        const dates = []
        // ENSURE THAT SETTING X AMOUNT OF DAYS IN A ROW TO BUSY MAKES ALL THOSE DAYS HAVE THEIR OWN ALL DAY BUSY EVENT
        if (endDate.getTime() - startDate.getTime() > 86400000) {
          while (date < endDate) {
            dates.push({
              start: moment(new Date(date).getTime()).format(),
              end: moment(new Date(date).getTime() + 86400000).format(),
            })
            date.setDate(date.getDate() + 1)
          }
        }
        if (dates.length > 0) {
          return dates
        } else {
          return el
        }
      })
      return busyTimes
    })

    const busyTimes = busy
      .flat()
      .flat()
      .sort((a, b) => a['start'].localeCompare(b['start']))

    // ENSURE THAT IF THERE IS AN ALL DAY BUSY EVENT NO OTHER BUSY EVENT IS BEING PROCESSED
    const busytimes1 = busyTimes.filter((el) => {
      let returnBool = true
      busyTimes.forEach((el1) => {
        if (new Date(el['start']).getDate() === new Date(el1['start']).getDate()) {
          if (
            new Date(el['start']).getDate() === new Date(el['end']).getDate() &&
            new Date(el1['start']).getDate() !== new Date(el1['end']).getDate()
          ) {
            returnBool = false
          }
        }
      })
      return returnBool
    })

    setBusy(busytimes1)
  }

  useEffect(() => {
    async function openCalendar() {
      const viewDate = new moment(Date.now())
      setRandomDateOfCurrentMonth(viewDate)
      const timezone = ts.getFuzzyLocalTimeFromPoint(viewDate.unix() * 1000, [
        pack.photographer.location.longitude,
        pack.photographer.location.latitude,
      ])
      setTimeZone(timezone.tz())
      const viewDateStr = viewDate.format()

      let firstDate = viewDate
      firstDate.startOf('month')

      let lastDate = moment.tz(viewDateStr, timezone.tz())
      lastDate.endOf('month')

      const body = {
        timeMin: firstDate.toISOString(),
        timeMax: lastDate.toISOString(),
        timeZone: timezone.tz(),
        callback: `${LINK_BASE}/admin/calendar`,
        photographerEmail: `${pack.photographerEmail}`,
      }

      const response = await getOriginalFreeBusy(source, body)

      if (response.status !== 200) {
        setBusy([])
        if (response.data[0] !== 'user has not authed') {
          throw new Error(response.data)
        }
      }

      if (response.status === 200) {
        cleanData(response.data.calendars)
      } else {
        // If photographer hasn't connected google calendar or token expired
        setBusy([])
        // setUnauth(true)
      }
    }
    openCalendar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!!showForm && (showForm === 7 || showForm.length > 1) && !!pack?.showCalendar) {
      setPage(1)
    }
  }, [showForm])

  // Anytime date is selected, filter busy array and calculate free timeslots
  const handleDateChange = async (date) => {
    // shouldn't manipulate date moment directly
    // unix is Correct value
    const viewDate = new moment(Date.now())
    const timezone = ts.getFuzzyLocalTimeFromPoint(viewDate.unix() * 1000, [
      pack.photographer.location.longitude,
      pack.photographer.location.latitude,
    ])

    const dateStr = date.format()
    const newCurrentDate = new moment.tz(dateStr, timezone.tz())
    const dayofweek = newCurrentDate.weekday()

    let workTimeArr
    if (pack.photographer.calendarWorkDays.length !== 0) {
      workTimeArr = JSON.parse(
        pack.photographer.calendarWorkDays.filter((el) => el.day === weekDays[dayofweek])[0].workTimes,
      )
    } else {
      workTimeArr = [
        {
          start: JSON.parse(pack.photographer.startWorkTime).hour.toString() + '00',
          end: JSON.parse(pack.photographer.endWorkTime).hour.toString() + '00',
        },
      ]
    }

    const uDate = date.unix()
    if (date._isValid) {
      // Everytime moment object is mutable, thus, make several copies as needed
      const fixedDate = moment(uDate * 1000)
      const fixedDate1 = moment(uDate * 1000)

      const fixedDate2 = moment((uDate + 86400) * 1000)

      setValues({
        ...values,
        uDate: uDate,
        date: fixedDate,
        time: pack.useTimePicker ? null : { hour: 8, minute: 1 },
      })

      const dailyBusy = disambleOverOneDay(busy)
      const filteredBusy = dailyBusy.filter(
        (el) => fixedDate1.isSameOrBefore(el['start']) && fixedDate2.isSameOrAfter(el['end']) === true,
      )

      const selectDate = moment(date).format('YYYYMMDD')
      const todayDate = DateTime.now().setZone(timezone.tz()).toFormat('yyyyLLdd')

      const isToday = selectDate === todayDate

      let timeSlots = []

      workTimeArr
        .sort((a, b) => Number(a.start) - Number(b.start))
        .forEach((time) => {
          const timeSlot = freeTimeSlots(
            filteredBusy,
            { hour: Number(time.start.slice(-4, -2)), minute: 0 },
            { hour: Number(time.end.slice(-4, -2)), minute: 0 },
            pack.hoursOfCoverage,
            JSON.parse(pack.photographer.buffer),
            timeZone,
            isToday,
          )

          timeSlots = timeSlots.concat(timeSlot)
        })

      if (!pack.useTimePicker) {
        setOpenTimeSlots(false)
        setExpandCalendar(false)
      }

      setFreeTimes(timeSlots)
    }
  }

  const renderDay = (props, currentDate, selectedDate) => {
    const timezone = ts.getFuzzyLocalTimeFromPoint(currentDate.unix() * 1000, [
      pack.photographer.location.longitude,
      pack.photographer.location.latitude,
    ])

    const uDate = currentDate.unix()
    const fixedDate = moment(uDate * 1000)

    const fixedDate1 = moment((uDate + 86400) * 1000)
    const dateStr = currentDate.format()

    const newCurrentDate = new moment.tz(dateStr, timezone.tz())
    const dayofweek = newCurrentDate.weekday()

    let workTimeArr
    if (pack.photographer.calendarWorkDays.length !== 0) {
      workTimeArr = JSON.parse(
        pack.photographer.calendarWorkDays.filter((el) => el.day === weekDays[dayofweek])[0].workTimes,
      )
    } else {
      workTimeArr = [
        {
          start: JSON.parse(pack.photographer.startWorkTime).hour.toString() + '00',
          end: JSON.parse(pack.photographer.endWorkTime).hour.toString() + '00',
        },
      ]
    }

    let timeSlots = []
    let invalid
    // Dont't run the code for past month date, because some day are same(may have two 29,30,31)
    if (!newCurrentDate.isBefore(moment().startOf('day').format())) {
      const dailyBusy = disambleOverOneDay(busy)

      const filteredBusy = dailyBusy.filter(
        (el) => !!fixedDate.isSameOrBefore(el['start']) && !!fixedDate1.isSameOrAfter(el['end']),
      )

      workTimeArr
        .sort((a, b) => Number(a.start) - Number(b.start))
        .forEach((time) => {
          const timeSlot = freeTimeSlots(
            filteredBusy,
            { hour: Number(time.start.slice(-4, -2)), minute: 0 },
            { hour: Number(time.end.slice(-4, -2)), minute: 0 },
            pack.hoursOfCoverage,
            JSON.parse(pack.photographer.buffer),
            timeZone,
          )

          timeSlots = timeSlots.concat(timeSlot)
        })
    }

    const today = new moment.tz(timezone.tz())
    const date1 = today.date()
    const month1 = today.month()

    let multipleWeeksLater

    if (!!pack.weeksAvailable) {
      multipleWeeksLater = today.clone().add(pack.weeksAvailable, 'weeks')
    }

    // Should allow today on calendar
    if (props['data-value'] === date1 && props['data-month'] === month1) {
      const dayofweek = newCurrentDate.weekday()
      const todayActive = pack.photographer.calendarWorkDays.filter((el) => el.day === weekDays[dayofweek])[0]
        .active

      invalid = !todayActive
    } else if (
      pack.photographer.calendarWorkDays.length !== 0 &&
      !pack.photographer.calendarWorkDays.filter((el) => el.day === weekDays[dayofweek])[0].active
    ) {
      invalid = true
    } else if (!!pack.weeksAvailable) {
      invalid = newCurrentDate.isAfter(multipleWeeksLater)
    } else {
      invalid = newCurrentDate.isBefore(new Date()) || timeSlots.length === 0
    }

    if (!!invalid) {
      return (
        <InValidTD {...props} past={true} disabled>
          {props['data-value']}
        </InValidTD>
      )
    } else {
      return (
        <TD {...props} past={false} onClick={() => handleDateChange(newCurrentDate)}>
          {props['data-value']}
        </TD>
      )
    }
  }

  // Anytime months view changes, trigger this function to make freebusy call
  const handleMonthChange = async (viewDate) => {
    const timezone = ts.getFuzzyLocalTimeFromPoint(viewDate.unix() * 1000, [
      pack.photographer.location.longitude,
      pack.photographer.location.latitude,
    ])

    const viewDateStr = viewDate.format()

    let firstDate = viewDate
    firstDate.startOf('month')

    let lastDate = moment.tz(viewDateStr, timezone.tz())
    lastDate.endOf('month')

    const body = {
      timeMin: firstDate.toISOString(),
      timeMax: lastDate.toISOString(),
      timeZone: timezone.tz(),
      callback: `${LINK_BASE}/admin/calendar`,
      photographerEmail: `${pack.photographerEmail}`,
    }

    const response = await getOriginalFreeBusy(source, body)

    // ERROR REPORTING
    if (response.status !== 200) {
      setBusy([])
      if (response.data[0] !== 'user has not authed') {
        throw new Error(response.data)
      }
    }

    if (response.status === 200) {
      cleanData(response.data.calendars)
    } else {
      // If photographer hasn't connected google calendar or token expired
      setBusy([])
      // setUnauth(true)
    }
  }

  const handleTimeChange = (time) => {
    setValues({ ...values, time })
    setExpandCalendar(false)
    setTimeTBD(false)
  }

  const parseBookingAddons = (addons) => {
    let parsedAddOns = []
    addons.forEach((addon) => {
      parsedAddOns.push({
        name: addon.packageAddOnTemplate.name,
        price: addon.packageAddOnTemplate.price,
        addedToOrder: addon.addedToOrder,
      })
    })
    return parsedAddOns
    //TODO add error handling/sentry
  }

  const submit = () => {
    if (blockSubmit) return

    setBlockSubmit(true)
    setTimeout(() => {
      setBlockSubmit(false)
    }, 3000)

    if (isForPreview) return

    const principalEmail = packageForm.filter((el) => el.fieldType === 5)[0].fieldValue
    const principalName = packageForm.filter((el) => el.fieldType === 1)[0].fieldValue
    const principalPhone = packageForm.filter((el) => el.fieldType === 4)[0].fieldValue
    const principalMessage = packageForm.filter((el) => el.fieldType === 2)[0].fieldValue

    const newErrors = BookingRequestValidation(packageForm, {})

    packageForm
      .filter((el) => el.fieldType === 5 && !!el.required)
      .forEach((el) => {
        if (!isValidEmail(pack.photographerEmail, el.fieldValue)) {
          Object.assign(newErrors, { email: 'This email cannot be used, please use another' })
        }
      })

    setErrors(newErrors)
    if (Object.keys(newErrors).length === 0) {
      let calcUDate
      if (!values.uDate) {
        calcUDate = null
      } else {
        calcUDate = values.uDate + (values.time.hour * 3600 + values.time.minute * 60)
      }

      const body = {
        proposedDatetime: calcUDate,
        message: principalMessage,
        marketplace: marketplace,
        package: pack.identifier,
        customer: {
          email: principalEmail,
          name: principalName,
        },
        contactPhoneNumber: principalPhone,
        bookingAddOns: parseBookingAddons(addOns),
        messageJson: JSON.stringify(packageForm),
        //TODO
      }
      setWaitingForResponse(true)
      createBookingRequest(body, source).then((response) => {
        if (response.status === 201) {
          setWaitingForResponse(false)
          Event('BOOKING REQUEST', 'CREATED', `Booking request created by ${body.customer.name}`)
          setValues({
            date: '',
            uDate: '',
            name: '',
            email: '',
            note: '',
            time: null,
            phone: '',
            placeholderMessage: '',
          })
          setFreeTimes(null)
          setPage(2)
          setTimeout(function () {
            setLoadComplete(true)
          }, 3000)
        } else {
          setWaitingForResponse(false)
          setPage(3)
        }
      })
    }
  }

  //For Disabled Past Days on Calendar
  const yesterday = moment().subtract(1, 'd')
  const disablePastDt = (current) => {
    return current.isAfter(yesterday)
  }

  return (
    <Container id="booking-request-modal">
      {pack && pack.showCalendar ? (
        <Modal>
          {page === 0 && (
            <Form page={page}>
              <Header>
                <DateButton
                  onClick={() => {
                    if (!timeTBD) {
                      setExpandCalendar(!expandCalendar)
                    }
                  }}
                  color={colorObj.text}
                  background={colorObj.background}
                >
                  <DateLabel>Date</DateLabel>
                  <ButtonText>
                    {' '}
                    {!!timeTBD
                      ? 'TBD'
                      : values.date
                      ? `${new moment.tz(
                          values.date,
                          ts
                            .getFuzzyLocalTimeFromPoint(values.uDate * 1000, [
                              pack.photographer.location.longitude,
                              pack.photographer.location.latitude,
                            ])
                            .tz(),
                        ).format(pack.useTimePicker ? 'MMMM D YYYY, z' : 'MMMM D YYYY')} ${
                          pack.useTimePicker && !timeTBD && values.date && values.time
                            ? `  , ${values.time.hour > 12 ? values.time.hour - 12 : values.time.hour}:${
                                values.time.minute === 0 ? '00' : values.time.minute
                              }
                            ${values.time.hour >= 12 ? 'PM' : 'AM'}`
                            : ''
                        }`
                      : 'Select Date and Time'}
                  </ButtonText>
                  <CalendarIcon />
                </DateButton>
                <TBDLabel htmlFor="TBD">
                  <CheckBox
                    type="checkbox"
                    checked={!!timeTBD}
                    onChange={() => {
                      setValues({ ...values, date: null, time: null, uDate: null })
                      if (!timeTBD) {
                        setTimeTBD(true)
                        setOpenTimeSlots(true)
                        setFreeTimes(null)
                      } else {
                        setTimeTBD(false)
                      }
                    }}
                    background={colorObj.background}
                    name={'TBD'}
                  />
                  TBD
                </TBDLabel>
              </Header>
              {!expandCalendar && values.uDate && (
                <NextButton
                  background={colorObj?.accent1}
                  onClick={() => {
                    setPage(1)
                  }}
                >
                  Next
                </NextButton>
              )}
              {!!expandCalendar && (
                <CalendarPopUp id="calendar-popup" background={colorObj.accent2} showTimeSlots={!!freeTimes}>
                  <CalendarWrapper>
                    <StyledReactDatetime
                      id="styled-react-datetime"
                      initialViewMode="days"
                      // hide={!!freeTimes}
                      isValidDate={disablePastDt}
                      timeFormat={!timeTBD}
                      dateFormat={!timeTBD}
                      value={values.date}
                      renderDay={renderDay}
                      isForPreview={isForPreview}
                      // onChange={(date) => handleDateChange(date)}
                      onBeforeNavigate={(nextView, currentView, viewDate) => {
                        if (currentView === 'months' && nextView === 'days') {
                          setRandomDateOfCurrentMonth(viewDate)
                          handleMonthChange(viewDate)
                        }
                        return nextView
                      }}
                      onNavigateForward={(num, mode) => {
                        if (mode === 'months') {
                          const nextMonthDate = randomDateOfCurrentMonth.add(num, 'months')
                          handleMonthChange(nextMonthDate)
                        }
                      }}
                      onNavigateBack={(num, mode) => {
                        if (mode === 'months') {
                          const nextMonthDate = randomDateOfCurrentMonth.subtract(num, 'months')
                          handleMonthChange(nextMonthDate)
                        }
                      }}
                      displayTimeZone={ts
                        .getFuzzyLocalTimeFromPoint(values.date, [
                          pack.photographer.location.longitude,
                          pack.photographer.location.latitude,
                        ])
                        .tz()}
                    />
                    {pack.useTimePicker && openTimeSlots && (
                      <TimeSlotsSection
                        freeTimes={freeTimes}
                        setFreeTimes={setFreeTimes}
                        colorObj={colorObj}
                        values={values}
                        setValues={setValues}
                        handleTimeChange={handleTimeChange}
                        pack={pack}
                      />
                    )}
                    {/* {pack.useTimePicker && openTimeSlots && (
                      <TimeSlots active={!!freeTimes}>
                        <Row1>
                          <Back
                            onClick={() => {
                              setFreeTimes(null)
                              setValues({ ...values, date: null, time: null, uDate: null })
                            }}
                            active={!!freeTimes}
                          >
                            <LeftArrow />
                            Back to Calendar
                          </Back>
                          <DateText active={!!freeTimes}>
                            {new moment.tz(
                              values.date,
                              ts
                                .getFuzzyLocalTimeFromPoint(values.uDate * 1000, [
                                  pack.photographer.location.longitude,
                                  pack.photographer.location.latitude,
                                ])
                                .tz(),
                            ).format('MMM Do YYYY, z')}
                          </DateText>
                        </Row1>
                        {!!freeTimes ? (
                          freeTimes.length === 0 ? (
                            'Not available for this package'
                          ) : (
                            <div>
                              {freeTimes.map((el, i) => {
                                let selected = false
                                if (
                                  values.time &&
                                  el.hour === values.time.hour &&
                                  el.minute === values.time.minute
                                ) {
                                  selected = true
                                }
                                return (
                                  <TimeButton key={i} onClick={() => handleTimeChange(el)} active={selected}>
                                    {el.hour > 12 ? el.hour - 12 : el.hour}:
                                    {el.minute === 0 ? '00' : el.minute}
                                    {el.hour >= 12 ? 'PM' : 'AM'}
                                  </TimeButton>
                                )
                              })}
                            </div>
                          )
                        ) : null}
                      </TimeSlots>
                    )} */}
                  </CalendarWrapper>
                </CalendarPopUp>
              )}
            </Form>
          )}
          {page === 1 && (
            <Form page={page}>
              <Label>
                Date{pack.useTimePicker && ` & Time`}
                <Back
                  onClick={() => {
                    if (!pack.useTimePicker) {
                      setFreeTimes(null)
                      setValues({
                        ...values,
                        date: '',
                        uDate: null,
                        time: null,
                      })
                    }
                    setPage(0)
                  }}
                  active={true}
                  page={1}
                >
                  <LeftArrow />
                  Back to Selecting
                </Back>
              </Label>
              {!!timeTBD ? (
                <div>
                  <SubLabel>Date</SubLabel>
                  <SelectedDate>TBD</SelectedDate>
                </div>
              ) : !!values.date && !!values.time ? (
                <div>
                  <SubLabel>Date</SubLabel>
                  <SelectedDate>
                    {`${new moment.tz(
                      values.date,
                      ts
                        .getFuzzyLocalTimeFromPoint(values.uDate * 1000, [
                          pack.photographer.location.longitude,
                          pack.photographer.location.latitude,
                        ])
                        .tz(),
                    ).format(pack.useTimePicker ? 'MMM Do YYYY, z' : 'MMM Do YYYY')}`}
                    {pack.useTimePicker &&
                      `, ${values.time.hour > 12 ? values.time.hour - 12 : values.time.hour}:
                    ${values.time.minute === 0 ? '00' : values.time.minute}
                    ${values.time.hour >= 12 ? 'PM' : 'AM'}`}
                  </SelectedDate>
                </div>
              ) : (
                <div>
                  <SubLabel>Date</SubLabel>
                  <SelectedDate>
                    <PlaceholderText>{`You haven't selected date & time`}</PlaceholderText>
                  </SelectedDate>
                </div>
              )}
              <Label>Information</Label>
              {!!packageForm ? (
                <FormContainer>
                  {packageForm.slice(1).map((el, i) => {
                    return el?.fieldType === 2 ? (
                      <div key={`info-${i}`}>
                        {' '}
                        <SubLabel>
                          {el?.fieldLabel}
                          {!!el?.required && ' *'}
                        </SubLabel>
                        <TextArea
                          id={`booking-request-${i}`}
                          style={{ fontSize: '16px' }}
                          name={el?.fieldLabel}
                          type="text"
                          value={el?.fieldValue}
                          placeholder={el?.fieldPlaceHolder}
                          onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                          error={!!Object.keys(errors).includes(el?.fieldLabel)}
                        />
                        {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                          <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                        )}
                      </div>
                    ) : (
                      <div key={`info-${i}`}>
                        <SubLabel>
                          {el?.fieldLabel}
                          {!!el?.required && ' *'}
                        </SubLabel>
                        <Input
                          id={`booking-request-${i}`}
                          style={{ fontSize: '16px' }}
                          name={el?.fieldLabel}
                          type="text"
                          value={el?.fieldValue}
                          placeholder={el?.fieldPlaceHolder}
                          onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                          error={!!Object.keys(errors).includes(el?.fieldLabel)}
                        />
                        {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                          <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                        )}
                      </div>
                    )
                  })}
                </FormContainer>
              ) : (
                <FormContainer>
                  <div>
                    <SubLabel>Name</SubLabel>
                    <Input
                      id="booking-request-name"
                      style={{ fontSize: '16px' }}
                      name="name"
                      type="text"
                      value={values.name}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('name')}
                    />
                    {!!Object.keys(errors).includes('name') && <ErrorMsg>{errors.name}</ErrorMsg>}
                  </div>
                  <div>
                    <SubLabel>Email</SubLabel>
                    <Input
                      id="booking-request-email"
                      style={{ fontSize: '16px' }}
                      name="email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('email')}
                    />
                    {!!Object.keys(errors).includes('email') && <ErrorMsg>{errors.email}</ErrorMsg>}
                  </div>
                  <div>
                    <SubLabel>Phone</SubLabel>
                    <Input
                      id="booking-request-phone"
                      style={{ fontSize: '16px' }}
                      name="phone"
                      type="text"
                      value={values.phone}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('phone')}
                    />
                    {!!Object.keys(errors).includes('phone') && <ErrorMsg>{errors.phone}</ErrorMsg>}
                  </div>

                  <QuestionWrapper>
                    <SubLabel1>Message</SubLabel1>
                    {!!pack.placeholderMessage && <Question>{pack.placeholderMessage}</Question>}
                    <QInput
                      id="booking-request-note"
                      style={{ fontSize: '16px' }}
                      name="note"
                      type="text"
                      value={values.note}
                      onChange={handleChange}
                    />
                    {!!Object.keys(errors).includes('note') && <ErrorMsg>{errors.note}</ErrorMsg>}
                  </QuestionWrapper>
                </FormContainer>
              )}

              {addOns && addOns.length > 0 && <H3 style={{ margin: '0px', padding: '0px' }}>Add - Ons</H3>}
              <PackageAddOnSelection setAddOns={setAddOns} addOns={addOns}></PackageAddOnSelection>

              <ButtonRow>
                <SubmitButton
                  disabled={waitingForResponse || isForPreview}
                  onClick={submit}
                  background={colorObj?.accent1}
                >
                  {waitingForResponse ? <SpinLoader size={28}></SpinLoader> : 'Request Booking'}
                </SubmitButton>
              </ButtonRow>
            </Form>
          )}
          {page === 2 && (
            <Form page={page}>
              <AnimatedCheckMark loadComplete={loadComplete} />
              {loadComplete && <H3>Booking Request Sent Successfully</H3>}
            </Form>
          )}
          {page === 3 && (
            <Form page={page}>
              <XMark />
              {loadComplete && <H3>Booking Request Sent Failed</H3>}
            </Form>
          )}
        </Modal>
      ) : (
        // Calendar is hidden
        <Modal>
          {page === 0 && (
            <Form>
              <Label>Information</Label>
              {!!packageForm ? (
                <FormContainer>
                  {packageForm.slice(1).map((el, i) => {
                    return el?.fieldType === 2 ? (
                      <div>
                        {' '}
                        <SubLabel>
                          {el?.fieldLabel}
                          {!!el?.required && ' *'}
                        </SubLabel>
                        <TextArea
                          id={`booking-request-${i}`}
                          style={{ fontSize: '16px' }}
                          name="note"
                          type="text"
                          value={el?.fieldValue}
                          placeholder={el?.fieldPlaceHolder}
                          onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                          error={!!Object.keys(errors).includes(el?.fieldLabel)}
                        />
                        {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                          <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                        )}
                      </div>
                    ) : (
                      <div>
                        <SubLabel>
                          {el?.fieldLabel}
                          {!!el?.required && ' *'}
                        </SubLabel>
                        <Input
                          id={`booking-request-${i}`}
                          style={{ fontSize: '16px' }}
                          name="name"
                          type="text"
                          value={el?.fieldValue}
                          placeholder={el?.fieldPlaceHolder}
                          onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                          error={!!Object.keys(errors).includes(el?.fieldLabel)}
                        />
                        {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                          <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                        )}
                      </div>
                    )
                  })}
                </FormContainer>
              ) : (
                <FormContainer>
                  <div>
                    <SubLabel>Name</SubLabel>
                    <Input
                      id="booking-request-name"
                      style={{ fontSize: '16px' }}
                      name="name"
                      type="text"
                      value={values.name}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('name')}
                    />
                    {!!Object.keys(errors).includes('name') && <ErrorMsg>{errors.name}</ErrorMsg>}
                  </div>
                  <div>
                    <SubLabel>Email</SubLabel>
                    <Input
                      id="booking-request-email"
                      style={{ fontSize: '16px' }}
                      name="email"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('email')}
                    />
                    {!!Object.keys(errors).includes('email') && <ErrorMsg>{errors.email}</ErrorMsg>}
                  </div>
                  <div>
                    <SubLabel>Phone</SubLabel>
                    <Input
                      id="booking-request-phone"
                      style={{ fontSize: '16px' }}
                      name="phone"
                      type="text"
                      value={values.phone}
                      onChange={handleChange}
                      error={!!Object.keys(errors).includes('phone')}
                    />
                    {!!Object.keys(errors).includes('phone') && <ErrorMsg>{errors.phone}</ErrorMsg>}
                  </div>
                  <QuestionWrapper>
                    <SubLabel1>Message</SubLabel1>
                    {!!pack.placeholderMessage && <Question>{pack.placeholderMessage}</Question>}
                    <QInput
                      id="booking-request-note"
                      style={{ fontSize: '16px' }}
                      name="note"
                      type="text"
                      value={values.note}
                      onChange={handleChange}
                    />
                    {!!Object.keys(errors).includes('note') && <ErrorMsg>{errors.note}</ErrorMsg>}
                  </QuestionWrapper>
                </FormContainer>
              )}

              {addOns && addOns.length > 0 && <H3 style={{ margin: '0px', padding: '0px' }}>Add - Ons</H3>}
              <PackageAddOnSelection setAddOns={setAddOns} addOns={addOns}></PackageAddOnSelection>
              <ButtonRow>
                <SubmitButton
                  disabled={waitingForResponse || isForPreview}
                  onClick={submit}
                  background={colorObj?.accent1}
                >
                  Request Booking
                </SubmitButton>
              </ButtonRow>
            </Form>
          )}
          {page === 2 && (
            <Form page={page}>
              <AnimatedCheckMark loadComplete={loadComplete} />
              {loadComplete && <H3>Booking Request Sent Successfully</H3>}
            </Form>
          )}
          {page === 3 && (
            <Form page={page}>
              <XMark />
              {loadComplete && <H3>Booking Request Sent Failed</H3>}
            </Form>
          )}
        </Modal>
      )}
    </Container>
  )
}

const Modal = styled.div`
  width: 100%;
  height: auto;
  background: inherit;
  z-index: 99;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  font-size: 16px;
`

const Container = styled.div`
  display: flex;
`

const Label = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: var(--black);
  font-size: 18px;
  margin: 0.5em 0;
  line-height: 1.5;
`

const TBDLabel = styled.label`
  display: flex;
  font-weight: 400;
  color: var(--black);
  font-size: 14px;
  line-height: 1.5;
`

const SubLabel = styled.label`
  font-size: 12px;
  position: absolute;
  color: var(--dark-grey-2);
  z-index: 2;
  margin: 8px 0 0 8px;
`

const SubLabel1 = styled(SubLabel)`
  position: relative;
`

const Input = styled.input`
  position: relative;
  width: 100%;
  margin: 0 0 0.5em 0;
  height: auto;
  padding: 2em 0.5em 0.5em 0.5em;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  border-radius: 0;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  &:focus {
    border: 1px solid var(--forward);
  }
`

const Question = styled.div`
  z-index: 4;
  margin: 0.5em;
  background-color: #fafafa;
  padding: 0.5em;
  border-radius: 0.3em;
  font-size: 14px;
  width: auto;
`

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 250px;
  margin: 0 0 0.5em 0;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  &:focus {
    border: 1px solid var(--forward);
  }
  @media (max-width: 420px) {
    height: 300px;
  }
`

const QInput = styled.textarea`
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  margin: 0 0 0 0.5em;
  padding: 0 0.5em 0 0;
  z-index: 9;
  resize: none;
  font-size: 14px;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  overflow-y: scroll;
`

const TextArea = styled.textarea`
  width: -webkit-fill-available;
  margin: 0 0 0.5em 0;
  padding: 2em 0.5em 0.5em 0.5em;
  z-index: 9;
  resize: none;
  font-size: 14px;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  overflow-y: scroll;
`

const ErrorMsg = styled.div`
  font-size: 12px;
  color: var(--error);
  margin: 0 0 0.5em 0;
`

const Form = styled.div`
  padding: 0;
  font-family: inherit;
  ${(props) =>
    (props.page === 2 || props.page === 3) &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    `}
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const ButtonText = styled.div`
  display: flex;
  justify-content: flex-start;
  font-weight: 300;
  font-size: 18px;
  width: 100%;
`

const SelectedDate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--light-grey-2);
  background-color: #f0f0f0;
  padding: 30px 15px 15px 8px;
  margin: 0 0 1em 0;
`
const PlaceholderText = styled.div`
  color: var(--dark-grey-2);
  font-size: 14px;
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1em 0 0 0;
  font-family: inherit;
`

const NextButton = styled.button`
  background-color: ${(props) => props.background || 'var(--black)'};
  font-size: 0.9em;
  padding: 1em 1.5em;
  font-family: inherit;
  width: 100%;
  margin: 24px 0 0 0;
  :hover {
    transition: all 0.2s ease 0s;
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
  }
`

const SubmitButton = styled.button`
  background-color: ${(props) => props.background || 'var(--black)'};
  font-size: 0.9em;
  padding: 1em 6.5em;
  font-family: inherit;
  :hover {
    opacity: 0.8;
    transition: all 0.2s ease 0s;
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
  }
  opacity: ${(props) => (props.disabled === false ? '1' : '0.65')};
`

const Row1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Back = styled.div`
  display: ${(props) => (props.active ? 'flex' : 'none')};
  align-items: center;
  color: var(--dark-grey-2);
  font-size: 14px;
  cursor: pointer;
  margin: 0 0 1em 0;
  ${(props) =>
    props.page === 1 &&
    css`
      margin: 0;
    `}
  :hover {
    color: var(--dark-grey-1);
  }
`

const LeftArrow = styled(MdKeyboardArrowLeft)`
  font-family: inherit;
  color: inherit;
  margin: 2px 2px 0 -3px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const DateButton = styled.button`
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  font-size: 300;
  background-color: ${(props) => props.background};
  color: ${(props) => props.color};
  height: auto;
  width: 80%;
  height: 100%;
`

const DateLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 13px;
  text-transform: uppercase;
  width: 100%;
  font-weight: 600;
  margin: 0 0 10px 0;
`

const CheckBox = styled.input`
  width: 18px;
  height: 18px;
  margin: 0 5px 0 0;
  accent-color: ${(props) => props.background};
`

const TimeSlots = styled.div`
  display: flex;
  flex-direction: column;
  width: 490px;
  @media (max-width: 1520px) {
    width: 100%;
  }
  padding: ${(props) => (props.active ? '0 0 20px 0 ' : '0 0 20px 0')};
`

const TimeButton = styled.button`
  border: ${(props) => (props.active ? '1px solid var(--black)' : '1px solid var(--dark-grey-2)')};
  color: ${(props) => (props.active ? '#fff' : 'var(--dark-grey-2)')};
  background: ${(props) => (props.active ? 'var(--black)' : 'transparent')};
  font-size: 0.8em;
  font-weight: 450;
  padding: 1em 1.25em;
  margin: 0.5em 0.5em 0.5em 0;
  width: 78px;
  :hover {
    background: ${(props) => (props.active ? 'var(--black)' : 'var(--dark-grey-1)')};
    color: #fff;
  }
  @media (max-width: 500px) {
    font-size: 0.75em;
    padding: 0.75em;
    margin: 0.5em 0.3em 0.5em 0;
    width: 75px;
  }
`

const H3 = styled.h3`
  color: var(--black);
  font-size: 1.2em;
  margin: 0 0 2em 0;
  @media (max-width: 500px) {
    font-size: 1em;
    font-weight: 400;
  }
`

const DateText = styled.div`
  display: ${(props) => (props.active ? 'flex' : 'none')};
  align-items: center;
  margin: 0 2em 1em 0;
  color: var(--dark-grey-2);
  font-size: 14px;
`

const CalendarIcon = styled(VscCalendar)`
  position: absolute;
  right: 10px;
`

const CalendarPopUp = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  transition: all 0.35s ease-in-out;
  @media (min-width: 850px) {
    position: absolute;
    background: ${(props) => props.background};
    padding: 30px 40px;
    right: ${(props) => (props.showTimeSlots ? '0%' : '15%')};
    width: auto;
  }
`

const CalendarWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 680px) {
    flex-direction: column;
  }
`

const XMark = styled(VscError)`
  font-size: 110px;
  color: var(--error);
  margin: 20px 0;
`

const StyledReactDatetime = styled(ReactDatetime)`
  display: ${(props) => (props.hide ? 'none' : 'block')};
  margin: 0 0 0 -10px;
  width: 100%;
  max-width: 768px;

  & > input {
    display: none;
  }

  & > .rdtPicker {
    ${(props) =>
      props.isForPreview &&
      css`
        display: unset;
        border: none;
        background: transparent;
        box-shadow: none;
      `};

    background-clip: padding-box;
    top: 50px;
    margin-top: 0;

    & > .rdtTime {
      & > table {
        & > thead {
          & > tr {
            & > .rdtSwitch {
              color: #525f7f;
              font-size: 0.875rem;
              height: 36px;
            }
          }
        }

        & > tbody {
          & > tr {
            & > td {
              & > .rdtCounters {
                & > .rdtCounter {
                  width: 50px;
                  margin: 3px;
                  border-radius: 50%;
                  & > .rdtCount {
                    line-height: 25px;
                    padding: 7px;
                    height: 40px;
                    border: 1px solid transparent;
                  }
                }
                & > .rdtCounter:last-child {
                  & > .rdtCount {
                    color: var(--forward);
                    border-radius: 50%;
                    border: 1px solid var(--forward);
                  }
                }
                & > .rdtCounterSeparator {
                  margin: 3px;
                  padding: 7px;
                  width: 0;
                  border: 1px solid transparent;
                }
              }
            }
          }
        }
      }
    }

    & > .rdtDays,
    & > .rdtMonths,
    & > .rdtYears {
      cursor: pointer;
      & > table {
        width: 100%;
        & > thead {
          & > tr {
            & > th {
              width: 36px;
              height: 46px;
              font-size: 1em;
              border: none;
              border-radius: 0;
              @media (max-width: 1100px) {
                padding: 0;
              }
            }

            & > .rdtPrev {
              & > span {
                font-size: 20px;
              }
            }
            & > .rdtSwitch {
              font-size: 18px;
            }
            & > .rdtNext {
              & > span {
                font-size: 20px;
              }
            }
          }
        }

        & > tbody {
          & > tr {
            & > td {
              font-size: 1em;
              height: 46px;
              width: 36px;
              border: none;
              border-radius: 8px;
              padding: 0 25px;
              @media (max-width: 1400px) {
                padding: 0 15px;
              }
              @media (max-width: 500px) {
                padding: 0 10px;
              }
            }
            & > .rdtMonth {
              height: 50px;
              padding: 0 35px;
              @media (max-width: 500px) {
                padding: 0 15px;
              }
              :hover {
                background: #f0f0f0;
              }
            }
            & > .rdtDisabled {
              color: var(--light-grey-1);
              text-decoration: line-through;
              :hover {
                background-color: transparent;
                cursor: not-allowed;
              }
            }
            & > .rdtActive {
              background-color: var(--black);
              color: #fff;
              :hover {
                background-color: none;
              }
            }
            & > .rdtOld {
              opacity: 0;
            }
            & > .rdtNew {
              display: none;
              color: var(--dark-grey-2);
            }
          }
        }

        & > tfoot {
          display: none;
        }
      }
    }
  }
`
const TD = styled.td`
  color: ${(props) => (!!props.past ? 'var(--light-grey-1)' : 'var(--dark-grey-1)')};
  text-decoration: ${(props) => (!!props.past ? 'line-through !important' : 'none')};
  :hover {
    background-color: ${(props) => (!!props.past ? 'transparent !important' : '#f0f0f0')};
    cursor: ${(props) => (!!props.past ? 'not-allowed' : 'cursor')};
  }
`

const InValidTD = styled.td`
  color: var(--light-grey-1);
  text-decoration: line-through !important;
  :hover {
    background-color: transparent;
    cursor: not-allowed;
  }
`
